const Subscriptions = {};

export const unsubscribe = ({
  name,
  context,
} = {}) => {

  if (!name || !context || !Subscriptions[name]?.[context]) {
    return;
  }

  delete Subscriptions[name][context];
};

export const subscribe = ({
  name,
  context,
  callback,
} = {}) => {

  if (!name || !context || typeof callback !== 'function') {
    return;
  }

  if (typeof Subscriptions[name] !== 'object') {
    Subscriptions[name] = {};
  }

  Subscriptions[name][context] = callback;

  return () => unsubscribe({
    name,
    context,
  });
};

export const sendEvent = ({
  name,
  data,
} = {}) => {

  if (!name || typeof Subscriptions[name] !== 'object') {
    return;
  }

  for (const callback of Object.values(Subscriptions[name])) {

    if (typeof callback !== 'function') {
      continue;
    }

    callback(data);
  }
};